/**
 * Helper functions for Peak Season Inventory form.
 *
 * Maps peak season category IDs to the scheduled farm property category IDs they require:
 * - Grain (4) requires scheduled Grain (4)
 * - Hay (5) requires scheduled Hay (5)
 * - Chemicals, Seed and Miscellaneous (14) requires scheduled Other farm supplies (9)
 *
 * @see https://github.com/gobranch/branch/issues/29145
 */

export const PEAK_TO_SCHEDULED_CATEGORY_MAP = {
  4: '4', // Grain → Grain
  5: '5', // Hay → Hay
  14: '9' // Chemicals, Seed and Miscellaneous → Other farm supplies
};

/**
 * Resolves a category ID to its display value (e.g., "4" → "Grain").
 * Falls back to the raw ID if no matching category is found.
 */
export function getCategoryDisplayValue(categoryId, availableCategories) {
  if (!availableCategories) {
    return categoryId;
  }
  const match = availableCategories.find((cat) => cat.id === categoryId);
  return match?.value ?? categoryId;
}

/**
 * Filters peak season categories to only those whose required scheduled items
 * are present on the policy. E.g., "Grain" peak season is only available if
 * "Grain" is already scheduled in Coverage F.
 */
export function getFilteredPeakSeasonCategories(allPeakCategories, scheduledItemCategories) {
  if (!allPeakCategories?.length || !scheduledItemCategories?.length) {
    return [];
  }
  return allPeakCategories.filter((cat) => {
    const requiredScheduledId = PEAK_TO_SCHEDULED_CATEGORY_MAP[cat.id];
    return requiredScheduledId && scheduledItemCategories.includes(requiredScheduledId);
  });
}
